"use client";

import { useEffect, useState } from "react";
import { initI18n, getCurrentLocale, setLocale } from "@/lib/i18n";

export function I18nProvider({ children }: { children: React.ReactNode }) {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // 确保只在客户端执行
    if (typeof window === "undefined") return;

    try {
      // 在客户端初始化国际化
      const locale = getCurrentLocale();
      initI18n(locale);

      // 监听语言变化
      const handleStorageChange = (e: StorageEvent) => {
        if (e.key === "locale" && e.newValue) {
          setLocale(e.newValue as any);
        }
      };

      window.addEventListener("storage", handleStorageChange);

      // 强制重新渲染一次，确保所有组件获取到正确的翻译
      setTimeout(() => {
        setIsReady(true);
      }, 0);

      return () => window.removeEventListener("storage", handleStorageChange);
    } catch (error) {
      console.error("Failed to initialize i18n:", error);
      // 即使出错也设置为就绪，避免界面卡住
      setIsReady(true);
    }
  }, []);

  // 使用一个简单的加载状态，确保国际化初始化完成后再渲染内容
  if (!isReady && typeof window !== "undefined") {
    return (
      <div className="flex min-h-screen w-full items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-500 border-t-transparent"></div>
      </div>
    );
  }

  return <>{children}</>;
}
